import axios from "axios";

export default function(appConfig) {
  const customerModule = {
    namespaced: true,
    state: {
      addresses: null,
      deliveryAddress: null,
      isSubscribeNewsletter: null
    },
    mutations: {
      setAddresses(state, addresses) {
        state.addresses = addresses;
      },
      addAddress(state, address) {
        state.addresses.push(address);
      },
      clear(state) {
        state.addresses = null;
        state.isSubscribeNewsletter = false;
      },
      setIsSubscribeNewsletter(state, user) {
        state.isSubscribeNewsletter = user;
      },
      setDeliveryAddress(state, address) {
        state.deliveryAddress = address;

        localStorage.setItem("deliveryAddress", JSON.stringify(address));
      }
    },
    getters: {
      friendlyAddresses(state, getters, rootState) {
        return (state.addresses || []).map(address => {
          return getters.getFriendlyAddress(address);
        });
      },
      getFriendlyAddress: (state, getters, rootState) => address => {
        let address2 = address.address2 !== null ? ", " + address.address2 : "";
        return {
          id: address.id,
          name:
            address.address1 +
            ", " +
            address.city +
            ", " +
            address.state +
            ", " +
            address.postcode +
            ", " +
            address.country +
            address2,
          account: address.account
        };
      },
      getFriendlyAddressById: (state, getters, rootState) => id => {
        let addresses = getters.friendlyAddresses;
        let friendlyAddress;
        addresses.some(address => {
          if (address.id === parseInt(id)) {
            friendlyAddress = address;
            return true;
          }
        });

        return friendlyAddress;
      }
    },
    actions: {
      userChanged(context, user) {
        if (user) {
          context.dispatch("isSubscribeNewsletter");
          // context.commit('setIsSubscribeNewsletter', user.isSubscriber)
          context.dispatch("getAddresses");
        } else {
          context.commit("clear");
        }
      },
      isGuestSubs(context) {
        context.commit("setIsSubscribeNewsletter", true);
      },
      isSubscribeNewsletter(context, state) {
        return context
          .dispatch("auth/getAccessToken", null, { root: true })
          .then(accessToken => {
            return axios
              .get(
                `${appConfig.API_URL}/newsletter/sib-check-subscriber-exist/${context.rootState.auth.user.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then(result => {
                context.commit("setIsSubscribeNewsletter", result.data);
              });
          });
      },
      getAddresses(context) {
        return context
          .dispatch("auth/getAccessToken", null, { root: true })
          .then(accessToken => {
            return axios
              .get(
                `${appConfig.API_URL}/customers/${context.rootState.auth.user.uid}/addresses`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then(result => {
                context.commit("setAddresses", result.data);
              });
          });
      },
      addAddress(context, address) {
        let data = {
          line1: address.line1,
          zipCode: address.zipCode,
          location: address.location,
          address1: address.address1,
          address2: address.address2,
          postcode: address.postcode,
          city: address.city,
          state: address.state,
          country: address.country,
          addresstype: address.addresstype
          // addresstype: 'B',
        };

        // const cities = context.rootState.config.cities || {}
        // Object.keys(cities).some(cityId => {
        //   if (cities[cityId] === address.city) {
        //     data.cityId = cityId
        //     return true
        //   }
        // })

        return context
          .dispatch("auth/getAccessToken", null, { root: true })
          .then(accessToken => {
            return axios
              .post(
                `${appConfig.API_URL}/customers/${context.rootState.auth.user.uid}/addresses`,
                data,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then(result => {
                context.commit("addAddress", result.data);
                return result.data;
              });
          });
      },
      setDeliveryAddress(context, addressId) {
        const deliveryAddress = context.getters.getFriendlyAddressById(
          addressId
        );
        context.dispatch("cart/setAddress", deliveryAddress, { root: true });
        // context.dispatch('cart/setAddress', deliveryAddress, { root: true })
        // context.commit('setDeliveryAddress', deliveryAddress)
      },
      restore(context) {
        const deliveryAddress = JSON.parse(
          localStorage.getItem("deliveryAddress")
        );
        if (deliveryAddress) {
          context.commit("setDeliveryAddress", deliveryAddress);
        }
      }
    }
  };

  return customerModule;
}



// WEBPACK FOOTER //
// ./src/store/modules/customer.js